import { Component , OnInit} from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { BettingServiceService } from './services/betting_service/betting-service.service';
import { StmgService } from './services/state_Management/stmg.service';
import { StorageServicesService } from './services/storage_services/storage-services.service';
import { CommonServiceService } from './services/common_service/common-service.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private bettingService : BettingServiceService,
     private stmgService:StmgService,
     private storageService: StorageServicesService,
     private commonService: CommonServiceService,
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    this.getSportIcons();
    this.setDefaultLanguage();
    this.getLatestVersion();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  // get sport icons for initial load.
getSportIcons(){
  this.bettingService.getSportIcons().subscribe(data=>{
    this.updateSportIconsDataSTMG(data);
  })
}

updateSportIconsDataSTMG(d:any){
  this.stmgService.updateSportIcons(d);
}

setDefaultLanguage(){
  if(!this.storageService.getLocal("language")){
    this.stmgService.updatelanguage('en');
    this.storageService.localStore("language", 'en');
  }
  
}


getLatestVersion(){
  this.commonService.getVersion().subscribe(data=>{
    //console.log(data);
    this.stmgService.updateVersion(data.version);
    
  })
}


}




